define('collections/recurring_products',['require','collections/base','models/recurring_product'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/recurring_product");

    return BaseCollection.extend({
        model: Model,
        url: this.search ? 'recurring-licenses.json?search='+ this.search :'recurring-licenses.json'
    });
});

